import { Box, Typography } from "@mui/material";

import toolbarStyles from "../Toolbar.module.css";


interface AttitudeItemProps {
    label: string;
    value: string;
};

const AttitudeItem = (props: AttitudeItemProps): JSX.Element => {
    return (
        <Box className={toolbarStyles.attitude_item}>
            <Typography component="span" fontSize="small" sx={{ display: { xs: 'none', sm: 'initial' }}}>{props.label}: </Typography>
            <Typography component="span">{props.value}</Typography>
        </Box>
    );
};

export default AttitudeItem;